import React from 'react';
import { Snackbar } from '@mui/material';
import { useRecoilState } from 'recoil';
import { snackbarState } from '../atom/common';

const GlobalSnackbar = () => {
  const [snackbar, setSnackbar] = useRecoilState(snackbarState);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={snackbar.open}
      autoHideDuration={3000}
      onClose={handleClose}
      message={snackbar.message}
    />
  );
};

export default GlobalSnackbar;
